import React, { useEffect } from "react";
import SimilerBanner from "../components/similerBanner/SimilerBanner";
import DevelopingSolution from "../components/developingsolution/DevelopingSolution";
import Testimonial from "../components/testimonila/Testimonial";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import RoadMap from "../components/roadMap/RoadMap";
import WhoWeServe from "../components/who-we-serve/WhoWeServe";
import HighValues from "../components/high-values/HighValues";
import TypesOfBuild from "../components/types-of-build/TypesOfBuild";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import DevelopmentServices from "../components/development-services/DevelopmentServices";
import ContactSection from "../components/contactSection/ContactSection";
import {
  WebServicesFaqData,
  WebServicesHighvaluesData,
  WebServicesIndustryTabsData,
  WebServicesIndustryTabsItemsData,
} from "../data/web-app-service-page";
import NewEngagementModels from "../components/new-engagment-modal";
import {
  bannerContent,
  DevelopmentServicesData,
  mainBannerImg,
  schemaData,
  tabItems,
  tabs,
  TypesOfBuildData,
  webAppDevelopmentPageServices,
  WebAppservicesRoadMap,
  WhoWeServeData,
  WhyChooseBitsclanData,
} from "../data/web-app-services-data";
import { useTranslation } from "react-i18next";
import SimpleModels from "../components/simpleEngagementModels";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import OurServices from "../components/our-services/OurServices";
import { AiMlPageData } from "../data/ai-ml-data";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";

const MobileDevelopmentServices = () => {
  // ARABIC TRANSLATION DATA
  const { t } = useTranslation("developmentServicesSectionData");
  const DevelopmentSectionTabs = t("developmentServicesTabs", {
    returnObjects: true,
  });
  const developmentContent = t("developmentServicesContent", {
    returnObjects: true,
  });
  // FOR BANNER TRANSLATION
  const { t: tWebDevPage } = useTranslation("webAppDevelopmentPage");
  const bannerContent = tWebDevPage("webAppDevelopmentPageBanner", {
    returnObjects: true,
  });
  const keyFeatureContent = tWebDevPage("webDevPageKeyFeature", {
    returnObjects: true,
  });
  const whoWeServeSection = tWebDevPage("webDevWhoWeServeSection", {
    returnObjects: true,
  });
  const whyChoseBitsclan = tWebDevPage("webDevPageWhyChoseBitsclan", {
    returnObjects: true,
  });
  const highVlaueSectionData = tWebDevPage("webDevPageHighValuesData", {
    returnObjects: true,
  });
  const FaqSection = tWebDevPage("webDevPageFaqs", { returnObjects: true });
  const coverTheStackData = tWebDevPage("webDevPageCoverTheStack", {
    returnObjects: true,
  });
  const roadMapData = tWebDevPage("webDevPageRoadMap", { returnObjects: true });
  const industriesHeading = tWebDevPage("webDevPageIndustriesHeading", {
    returnObjects: true,
  });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("webAppDevTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Custom & Progressive Web App Development Services | Bitsclan</title>
        <meta
          name="description"
          content="Bitsclan offers best progressive web app development & design services. Our expert app developers build fast and secure custom ai powered cloud based web applications to enhance user experience and ROI."
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading={bannerContent?.shortHeading}
        mainHeading={bannerContent?.mainHeading}
        description={bannerContent?.description}
      />
      <TrustedPartner />

      <OurServices
        buttonText="Start Your Journey"
        servicesCardsData={webAppDevelopmentPageServices?.cardsData}
        shortHeading={webAppDevelopmentPageServices?.shortHeading}
        mainHeading={webAppDevelopmentPageServices?.mainHeading}
        description={webAppDevelopmentPageServices?.description}
      />

      <NewTestimonials
        shortHeading="Our Testimonials"
        mainHeading="Voices of <span>Global</span> Enterprises on Our Web Applications Excellence"
        description="Discover why businesses trust Bitsclan for cutting-edge Web Applications solutions. Read real feedback from clients who achieved success with our services."
      />

      <WhyChooseUs
        heading="Advantage of Partnering With Us"
        greenHeading="The Strategic "
        shortHeading="why Choose Us"
        content="Organizations trust us for delivering AI-powered chatbots, intelligent automation, & advanced web & mobile app solutions. By blending innovation with proven IT strategies, we turn business challenges into scalable opportunities for long-term growth."
        stats={[
          {
            number: "120+",
            title: "Successful Projects Delivered"
          },
          {
            number: "100+",
            title: "Associated Professionals"
          },
        ]}
      />

      <NewCaseStudySection shortHeading="Our case studies" heading="Trusted by the World's Leading Companies" description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries." />

      <CoverTheStack
        whereStart={coverTheStackData?.CoverTheStackContent?.defaultTabOpen}
        mainHeading={coverTheStackData?.CoverTheStackContent?.mainHeading}
        subHeading={coverTheStackData?.CoverTheStackContent?.sectionDescription}
        tabs={coverTheStackData?.tabs}
        tabItems={coverTheStackData?.tabItems}
      />

      <SimpleModels content={engagementModelsContent} />

      <PioneeringChange
        tabData={AiMlPageData.industries.tabData}
        // showIndustries={["Healthcare", "Fintech", "E-commerce & Retail", "Real Estate", "Automotive", "Education"]}
        shortHeading="Industries We Serve"
        greenHeading={"Through Web Applications Leadership"}
        mainHeading={"Redefining Industries "}
        content={
          "Driving innovation & transforming industries with advanced Web Applications expertise & actionable insights."
        }
      />

      {/* <DevelopmentServices
        tabs={DevelopmentSectionTabs}
        heading={developmentContent?.DevelopmentServicesWebPageHeading}
        subheading={developmentContent?.DevelopmentServicesWebPageDescription}
      /> */}

      <TypesOfBuild
        typeOfApps={keyFeatureContent?.TypesOfBuildDataAccordian}
        heading={keyFeatureContent?.mainHeading}
        sideImage="web-app-development-2.avif"
      />

      <WhoWeServe
        cardContent={whoWeServeSection?.WhoWeServeCards}
        heading={whoWeServeSection?.WhoWeServeSectionContent?.mainHeading}
        subHeading={
          whoWeServeSection?.WhoWeServeSectionContent?.sectionDescription
        }
      />

      <WhyChooseBitsclan
        tabs={whyChoseBitsclan?.WhyChooseBitsclanTabs}
        expandAllAccordions={true}
        heading={whyChoseBitsclan?.WhyChooseBitsclanContent?.mainHeading}
        subheading={
          whyChoseBitsclan?.WhyChooseBitsclanContent?.sectionDescription
        }
      />

      <HighValues
        heading={highVlaueSectionData?.webDevHighValueContent?.mainHeading}
        subHeading={
          highVlaueSectionData?.webDevHighValueContent?.sectionDescription
        }
        boxContent={highVlaueSectionData?.webDevHighValueCards}
        btnLink="#"
        btnText={
          highVlaueSectionData?.webDevHighValueContent?.sectionButtonText
        }
      />

      {/* <NewEngagementModels /> */}


      <RoadMap
        heading={roadMapData?.RoadMapContent?.mainHeading}
        description={roadMapData?.RoadMapContent?.sectionDescription}
        roadMapHeading={roadMapData?.RoadMapHeading}
        roadMapsteps={roadMapData?.RoadMapDescription}
      />

      {/* <IndustriesTabs mainheading={industriesHeading?.mainHeading} /> */}

      <DevelopingSolution
        heading="Developing Solutions That Transcend Mere Digital Transformation"
        subheading="We deliver innovative solutions that surpass digital transformation, driving impactful & lasting success."
      />

      <TrendsInsights
        specificClass="mobile-dev-page"
        category="web-developmet"
      />

      <SecondFaq
        specificClass="mobile-dev-page"
        faqs={FaqSection?.webServiceQuestionAnswer}
        mainHeading={FaqSection?.wePageFaqContent?.mainHeading}
        subHeading={FaqSection?.wePageFaqContent?.sectionDescription}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default MobileDevelopmentServices;
